import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

import { FONT_DISPLAY, FONT_MONO } from "../../theme/tokens";

const styles = (theme) => ({
  root: {
    maxWidth: 760,
    margin: "0 auto",
    padding: theme.spacing(8, 4),
  },
  eyebrow: {
    color: theme.palette.text.disabled,
    display: "block",
    marginBottom: theme.spacing(1),
  },
  status: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 800,
    fontSize: 64,
    lineHeight: 1,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  message: {
    fontSize: 20,
    marginBottom: theme.spacing(3),
  },
  hint: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  // Раньше стек-трейс рендерился как абзац с выключкой по ширине: сырой JSON,
  // свёрстанный как проза.
  stackTrace: {
    marginTop: theme.spacing(4),
    backgroundColor:
      theme.palette.type === "dark" ? "#0a0a0a" : theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    padding: theme.spacing(2),
  },
  stackTraceBody: {
    fontFamily: FONT_MONO,
    fontSize: 12,
    whiteSpace: "pre-wrap",
    overflowX: "auto",
    color: theme.palette.text.secondary,
    margin: 0,
  },
  summary: {
    cursor: "pointer",
    color: theme.palette.text.disabled,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
  },
});

class AllureDockerErrorPage extends Component {
  render() {
    const { classes } = this.props;
    let connectivityIssue = "";
    const errorMessage = this.props.error.message;
    if (errorMessage && errorMessage.includes("Network Error")) {
      connectivityIssue = (
        <React.Fragment>
          <Typography className={classes.hint}>
            The API at <code>{window._env_.ALLURE_DOCKER_API_URL}</code> is not reachable
            from this browser. Check the QA VPN and that the service is running.
          </Typography>
          <Typography className={classes.hint}>
            If it stays down, contact the QA platform owners.
          </Typography>
        </React.Fragment>
      );
    }

    return (
      <div className={classes.root}>
        <Typography variant="overline" className={classes.eyebrow}>
          Error
        </Typography>
        <div className={classes.status}>{this.props.error.status}</div>
        <Typography className={classes.message}>{this.props.error.message}</Typography>
        {connectivityIssue}
        {this.props.error.stackTrace && (
          <details className={classes.stackTrace}>
            <summary className={classes.summary}>Stack trace</summary>
            <pre className={classes.stackTraceBody}>{this.props.error.stackTrace}</pre>
          </details>
        )}
      </div>
    );
  }
}
export default withStyles(styles, { withTheme: true })(AllureDockerErrorPage);
